import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
const widthPx = window.innerWidth;
const heightPx = window.innerHeight;
const diagonalPx = Math.sqrt(widthPx ** 2 + heightPx ** 2).toFixed(0);

console.log(`Diagonal: ${diagonalPx} pixels`);
  return (
    <footer className="footer"><p className="ev-fs-11 mb-0">&copy; {new Date().getFullYear()} Pharmacoevidence and Bristol Myers Squibb. All rights reserved.</p></footer>
  );
};

export default Footer;